// extracted by mini-css-extract-plugin
export default {"cut":"pR9W3","cut--wait":"qOFus","cut--dark":"JnlUu","cut__link":"GwpFW","badge":"Ctv0u"};